/**
 * Optimizes image URLs by setting resize parameters for supported CDNs.
 * For Builder.io CDN URLs, sets width and webp format params.
 * For other URLs, returns them unchanged.
 */
export function optimizeImageUrl(
  url: string | null | undefined,
  width: number
): string {
  if (!url) return "";

  // Builder.io CDN - set width and format
  if (url.includes("cdn.builder.io")) {
    const u = new URL(url);
    u.searchParams.set("format", "webp");
    u.searchParams.set("width", String(width));
    return u.toString();
  }

  return url;
}
